import { render, staticRenderFns } from "./DisableReasonManagement.vue?vue&type=template&id=3719593a&scoped=true"
import script from "./DisableReasonManagement.vue?vue&type=script&lang=js"
export * from "./DisableReasonManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3719593a",
  null
  
)

export default component.exports